/**
 * EmptyCartState Component
 * Displays when the cart has no items
 */
export function EmptyCartState() {
  return (
    <div className="flex h-full flex-col items-center justify-center gap-3 py-12">
      <div className="flex h-16 w-16 items-center justify-center rounded-full bg-neutral-100">
        <i className="ri-shopping-cart-line text-3xl text-neutral-400"></i>
      </div>
      <div className="text-center">
        <h3 className="text-md font-bold text-neutral-900">
          Your cart is empty
        </h3>
        <p className="text-sm text-neutral-600">Add plans to get started</p>
      </div>
    </div>
  );
}
